import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';

export class DeltaChargesModel {

  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  delta: number;
  contractType: ContractTypeModel;
  isDeltaSignificativo: number;
  isClaims: number;
  note: string;
  isRecovery: number;
  provider: ProviderModel;
  actualMonthCharge: number;
  calculatedMonthCharge: number;

  constructor(id?: number, numAnnoMeseRif?: number, region?: RegionModel,
              localCustomer?: LocalCustomerModel, resourceUnit?: ResourcesUnitModel,
              delta?: number, contractType?: ContractTypeModel, note?: string, provider?: ProviderModel, isRecovery?: number,
              actualMonthCharge?: number, calculatedMonthCharge?: number) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.delta = delta;
    this.contractType = contractType;
    this.note = note;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.actualMonthCharge = actualMonthCharge;
    this.calculatedMonthCharge = calculatedMonthCharge;
  }

}
